export const calcDate = (date1, date2) => {
  var date3 = date2 - date1

  var days = Math.floor(date3 / (24 * 3600 * 1000))

  var leave1 = date3 % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))

  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))

  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(date3 / 1000)
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  }
}

/**
 * 日期格式化
 */
export function dateFormat(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
  // 如果传进来的是10位的时间戳 变成13位的
  if (timestamp.toString().length == 10) timestamp = timestamp * 1000
  // 如果到这一步，依然不是13位的时间戳，说明数据有问题
  timestamp = parseInt(timestamp)
  if (timestamp.toString().length != 13) return ''
  var date = new Date(timestamp)
  var Y = date.getFullYear()
  var M = date.getMonth() + 1
  var D = date.getDate()
  var hour = date.getHours()
  var min = date.getMinutes()
  var sec = date.getSeconds()
  if (format === 'YYYY') return Y
  else if (format === 'YYYY-MM') return Y + '-' + (M < 10 ? '0' + M : M)
  else if (format === 'YYYY-MM-DD') { return Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D) } else if (format === 'HH:mm:ss') {
    return (
      (hour < 10 ? '0' + hour : hour) +
      ':' +
      (min < 10 ? '0' + min : min) +
      ':' +
      (sec < 10 ? '0' + sec : sec)
    )
  } else if (format === 'YYYY-MM-DD HH:mm') {
    return (
      Y +
      '-' +
      (M < 10 ? '0' + M : M) +
      '-' +
      (D < 10 ? '0' + D : D) +
      ' ' +
      (hour < 10 ? '0' + hour : hour) +
      ':' +
      (min < 10 ? '0' + min : min)
    )
  } else if (format === 'YYYY-MM-DD HH:mm:ss') {
    return (
      Y +
      '-' +
      (M < 10 ? '0' + M : M) +
      '-' +
      (D < 10 ? '0' + D : D) +
      ' ' +
      (hour < 10 ? '0' + hour : hour) +
      ':' +
      (min < 10 ? '0' + min : min) +
      ':' +
      (sec < 10 ? '0' + sec : sec)
    )
  } else {
    return '--'
  }
}
